"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("./utils");
var event_info_1 = require("./event-info");
var EventInfoJson = /** @class */ (function () {
    function EventInfoJson() {
    }
    EventInfoJson.fromJson = function (json) {
        var _a;
        if (Object.keys((json === null || json === void 0 ? void 0 : json.date) || {}).length && !((_a = json === null || json === void 0 ? void 0 : json.dates) === null || _a === void 0 ? void 0 : _a.length))
            json.dates = [json === null || json === void 0 ? void 0 : json.date];
        return utils_1.factory(new event_info_1.EventInfo(), json);
    };
    EventInfoJson = tslib_1.__decorate([
        utils_1.StaticImplements()
    ], EventInfoJson);
    return EventInfoJson;
}());
exports.EventInfoJson = EventInfoJson;
//# sourceMappingURL=event-info-json.js.map